import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React, { useContext } from "react";
import { PRIMARY_COLOR_DarkNavyBlue } from "../../../constants/Colors";
import CustomTextField from "../../../general_components/CustomTextField";
import LoadingButton from "../../../general_components/LoadingButton";
import Editor from "../../subscribers/components/EmailEditor";
import { TeamContext } from "../../../contexts/TeamsContext";
import AddProfileImage from "./AddProfileImage";
import { convertToRaw} from "draft-js";




export default function TeamModal(props) {

  const { title, open, handleClose, text, handlerFunction, id, previousTeam } = props

  const {
    name, setName, teamProfileImage, setTeamProfileImage, designation, setDesignation,
    description, setDescription, allTeam, setAllTeam, teamProfileRawImage, setTeamProfileRawImage,
    isNewsFile, setIsNewsFile, editMode,setEditMode } = useContext(TeamContext);


  const handelSubmit = () => {
    const descriptionHtml = JSON.stringify(convertToRaw(description.getCurrentContent()));
    const data = {
      name: name,
      description: descriptionHtml,
      designation: designation,
      image: teamProfileRawImage?.file,
    };

    handlerFunction(data, id, previousTeam);
    setDescription("");
    handleClose();
    setTeamProfileImage(null);
    setTeamProfileRawImage(null);
  };


  
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md">
      <DialogTitle>
        <Typography
          variant={"h6"}
          style={{ color: PRIMARY_COLOR_DarkNavyBlue, fontWeight: "600" }}
        >
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent style={{ width: 400, paddingTop: 10 }}>
        <form>
          <Box display={"flex"} justifyContent={"space-around"}>
            <AddProfileImage
              teamProfileImage={teamProfileImage}
              teamProfileRawImage={teamProfileRawImage}
              isNewsFile={isNewsFile}
              setTeamProfileImage={setTeamProfileImage}
              setIsNewsFile={setIsNewsFile}
              setTeamProfileRawImage={setTeamProfileRawImage}
              editMode={editMode}
              setEditMode={setEditMode}
            />
          </Box>
          <CustomTextField
            value={name}
            onValueChange={setName}
            labelName="Name"
            required
            style={{ marginBottom: 15 }}
          />
          <CustomTextField
            value={designation}
            onValueChange={setDesignation}
            labelName="Designation"
            type="text"
            required
            style={{ marginBottom: 15 }}
          />
          <Editor
            labelName={"Description"}
            type={"null"}
            value={description}
            onValueChange={setDescription}
            isTeam={true}
          />
          <div onClick={handelSubmit} style={{ marginTop: 15 }}>
            <LoadingButton text={text} />
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
